import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { UserProfileHelper } from '@lura/shared'

export function RoleBasedRedirect() {
  const { user } = useAuth()

  if (!user?.profile) {
    return <Navigate to="/login" replace />
  }

  // Web Admins go to Users page
  if (UserProfileHelper.isWebAdmin(user)) {
    return <Navigate to="/users" replace />
  }

  // Study Admins and Clinicians go to Studies page
  if (UserProfileHelper.isStudyAdmin(user) || UserProfileHelper.isClinician(user)) {
    return <Navigate to="/studies" replace />
  }

  // Fallback to patients page
  return <Navigate to="/patients" replace />
}
